export function isWithinFiveMinutes(date1: Date, date2: Date): boolean {
  // Calcula a diferença em milissegundos
  const diffInMs = Math.abs(date1.getTime() - date2.getTime());

  // Converte 5 minutos para milissegundos (5 * 60 * 1000)
  const fiveMinutesInMs = 5 * 60 * 1000;

  // Retorna true se a diferença for menor ou igual a 5 minutos
  return diffInMs <= fiveMinutesInMs;
}
